'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Spinner = require('./Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Spinner2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Spinner/index.js
// module id = 279
// module chunks = 11